import { Helmet } from 'react-helmet';
import { mapToJsonLd } from './mapper';
import type { ReviewRowModel } from '@seek/libs-shared';

export interface SeoStructuredData {
  name: string;
  ratingCount: number;
  ratingValue: number;
  location?: string;
  logo?: string;
  reviews?: ReviewRowModel[];
  url?: string;
}
interface SeoStructuredDataProps {
  disableIndexing: boolean;
  data?: SeoStructuredData;
}

export const SeoStructuredData = ({
  data,
  disableIndexing,
}: SeoStructuredDataProps) => {
  if (!data) {
    return null;
  }

  return (
    <Helmet>
      {disableIndexing && <meta name="robots" content="noindex, noarchive" />}
      <script type="application/ld+json">
        {JSON.stringify(mapToJsonLd(data))}
      </script>
    </Helmet>
  );
};
